import { StatusFormatter } from '@components'

import { Flex, Spacing } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { invoiceStatusToTitleKey } from '../../../../../../constants/invoiceStatusToTitleKey'
import { InvoiceStatus as InvoiceStatusEnum } from '../../../../../../enums/invoiceStatus'
import { SalesDocumentDeliveryStatus } from '../../../../../../enums/salesDocumentDeliveryStatus'
import { DeliveryStatusIndicator } from '../../../../../DeliveryStatusIndicator'
import { invoiceStatusToStatusFormatterVariant } from './constants/invoiceStatusToStatusFormatterVariant'

interface InvoiceStatusProps {
  status: InvoiceStatusEnum
  deliveryStatus?: SalesDocumentDeliveryStatus | null
}

export const InvoiceStatus = ({ status, deliveryStatus }: InvoiceStatusProps): ReactElement => {
  const { t } = useTranslation()

  const variant = invoiceStatusToStatusFormatterVariant[status]
  const title = invoiceStatusToTitleKey[status]

  return (
    <Flex alignItems="center" gap={Spacing.S16} width="fit-content">
      <StatusFormatter title={t(title)} variant={variant} />
      {deliveryStatus === SalesDocumentDeliveryStatus.Sent && (
        <DeliveryStatusIndicator label={t('invoices.table.status.delivery_indicator.sent.tooltip')} />
      )}
    </Flex>
  )
}
